import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["expanded", "children", "className", "duration"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from "clsx";
import React from "react";
import { Transition } from "react-transition-group";
import { ENTERED, ENTERING, EXITED, EXITING } from "../../common/constants";
import * as transition from "./TransitionHandlers";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const TRANSITION_STYLES = {
  [ENTERING]: "pnr-expandable--expanding",
  [ENTERED]: "pnr-expandable--expanded",
  [EXITING]: "pnr-expandable--expanding",
  [EXITED]: "pnr-expandable--collapsed wf-u-visually-hidden-content"
};
export default function ExpandableTransition(_ref) {
  let {
    expanded,
    children,
    className,
    duration
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return _jsx(Transition, {
    in: expanded,
    timeout: duration,
    onEntering: transition.handleExpanding,
    onEntered: transition.handleExpanded,
    onExit: transition.handleCollapse,
    onExiting: transition.handleCollapsing,
    children: state => _jsx("div", _objectSpread(_objectSpread({
      className: clsx(TRANSITION_STYLES[state], className)
    }, otherProps), {}, {
      children: children
    }))
  });
}